// extracted by mini-css-extract-plugin
export default {"header":"IC","light":"JC","dark":"KC","headertitle":"LC","fname":"MC","headerContent":"NC","right":"OC","descriptionwrapper":"PC","appear":"QC","second":"RC","third":"SC","forth":"TC"};
    if(module.hot) {
      // 1713809679306
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  